import { blocksToPlainText } from './emailTemplateBlocks.js';
const SPAM_PATTERNS = [
    { re: /\bgratis\b/i, label: 'gratis' },
    { re: /\b100\s*%\b/i, label: '100%' },
    { re: /\bgarantie\b/i, label: 'garantie' },
    { re: /\bactie\b/i, label: 'actie' },
    { re: /\bklik hier\b/i, label: 'klik hier' },
    { re: /\bnu meteen\b/i, label: 'nu meteen' },
    { re: /\blimited time\b/i, label: 'limited time' },
    { re: /\bwinner\b/i, label: 'winner' },
    { re: /\$\$\$/i, label: '$$$' },
    { re: /[A-Z]{8,}/, label: 'ALL CAPS' },
];
function countWords(text) {
    return text.trim().split(/\s+/).filter(Boolean).length;
}
function avgSentenceWords(text) {
    const sentences = text.split(/[.!?]+\s+/).filter((s) => s.trim().length > 0);
    if (!sentences.length)
        return 0;
    const total = sentences.reduce((n, s) => n + countWords(s), 0);
    return total / sentences.length;
}
export function scoreEmailTemplateContent(input) {
    const bodyText = blocksToPlainText(input.blocks.filter((b) => b.type === 'divider' ||
        ((b.type === 'paragraph' || b.type === 'heading') && b.text.trim()) ||
        (b.type === 'cta' && b.label.trim())));
    const word_count = countWords(bodyText);
    const subject_length = input.subject.trim().length;
    const avg = avgSentenceWords(bodyText);
    let readability = 'good';
    if (avg > 22 || word_count > 180)
        readability = 'long';
    else if (avg > 16 || word_count > 130)
        readability = 'ok';
    const haystack = `${input.subject}\n${bodyText}`;
    const spam_hits = [];
    for (const { re, label } of SPAM_PATTERNS) {
        if (re.test(haystack))
            spam_hits.push(label);
    }
    let spam_risk = 'low';
    if (spam_hits.length >= 3)
        spam_risk = 'high';
    else if (spam_hits.length >= 1)
        spam_risk = 'medium';
    let backlink_touch0_ok = null;
    if (input.category === 'backlink') {
        backlink_touch0_ok = subject_length <= 55 && word_count <= 120;
    }
    return {
        word_count,
        subject_length,
        readability,
        spam_risk,
        spam_hits,
        backlink_touch0_ok,
    };
}
//# sourceMappingURL=templateContentScores.js.map